import React from 'react';
import {Button, Card, Col, message, Modal, Row, Table, Tabs,} from 'antd';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl-context';
import {operationTypeValue} from 'modules/certification/enums';
import {getGameList} from "../../modules/team/action";
import {
    addPersonCertification,
    getTeamCertificationInfo,
    getPersonCertificationList, onUpdatePersonCertificationUpOrDown,
    verifyCertifiacation,
    onUpdatePersonUserSuspend,
    onDeletePersonCertification
} from "../../modules/certification/action";
import CertificationInfoModel from "./components/CertificationInfoModel";
import CertificationFilter from "./components/CertificationFilter";
import AddCertificationModel from "./components/AddCertificationModel";
import UpdateCertificationModel from "./components/UpdateCertificationModel";
import Item from 'antd/lib/list/Item';

const {confirm} = Modal;
const {TabPane} = Tabs;

class Certification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            previewVisible: false,
            previewImage: '',
            operationType: operationTypeValue.INCREASE,
            isShowCertificationInfoModel: false, // 战队信息
            isShowAddCertificationModel: false,
            isShowUpdateCertificationInfoModel: false,
            seletionValue: null,
            page: 1,
            size: 10,
            brandId: '',
            status: 'SUCCESS', //显示所有参赛认证数据，不区分是否审核
        };
    }

    componentWillMount() {
        this.onGetTableData();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.personCertifications !== this.props.personCertifications) {
            this.setState({
                loading: false
            })
        }
    }

    //刷新界面数据
    onGetTableData = () => {
        const {getPersonCertificationList, getGameList} = this.props;
        const {page, size, status} = this.state;
        this.setState({
            loading: true
        })
        getPersonCertificationList({
            page: page, size: size
        });
        getGameList();
    }

    onPageChangeEvent = (current, pageSize) => {
        const {getPersonCertificationList} = this.props;
        getPersonCertificationList({
            page: current, size: pageSize
        });
        this.setState({
            page: current,
            size: pageSize,
            loading: true
        });
    }

    //添加参赛认证
    onAddFormSubmitConfirm = (values, personBrandData) => {
        let _this = this;
        confirm({
            content: '确认要添加该参赛认证吗?',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                _this.onAddFormSubmit(values, personBrandData);
            },
            onCancel() {
            },

        });
    }

    onAddFormSubmit = async (values, personBrandData) => {
        const {isShowAddCertificationModel} = this.state;
        const {addPersonCertification} = this.props;
        let filterArr = personBrandData.data.filter(item => item.id === values.brandId);
        values['game'] = filterArr.length > 0 ? filterArr[0].game : 'HPJY';
        await addPersonCertification(values);
        this.setState({
            loading: true
        })
        await this.onGetTableData();
        message.success('添加成功');
        this.setState({isShowAddCertificationModel: !isShowAddCertificationModel});
    }

    //修改参赛认证升降级
    onUpdateCertificationUpOrDown = (values, type) => {
        let _this = this;
        let tipText = type === 'UP' ? '升级' : '降级';
        values['type'] = type; 
        confirm({
            content: '确认要' + tipText + '该用户的参赛认证吗？',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                _this.onUpdateUpOrDownSubmit(values);
            },
            onCancel() {
            },
        });
    }

    onUpdateUpOrDownSubmit = async (values) => {
        console.log(values);
        const {onUpdatePersonCertificationUpOrDown} = this.props;
        let tipText = values.type === 'UP' ? '升级成功' : '降级成功';

        await onUpdatePersonCertificationUpOrDown(values);
        this.setState({
            loading: true
        });
        await this.onGetTableData();
        message.success(tipText);
    }

    //设置用户禁赛或解禁
    onUpdateUserSuspend = (certId, suspend) => {
        let _this = this;
        let content = suspend ? '确认要为该用户解除禁赛吗？' : '确认要将该用户禁赛吗？';
        confirm({
            content: content,
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                _this.onUpdateUserSuspendSubmit({certId, suspend: !suspend});
            },
            onCancel() {
            },
        });
    }

    onUpdateUserSuspendSubmit = async (values) => {
        console.log(values);
        const {onUpdatePersonUserSuspend} = this.props;

        await onUpdatePersonUserSuspend(values);
        this.setState({
            loading: true
        });
        await this.onGetTableData();
        message.success("操作成功");
    }

    //删除参赛认证
    onDeleteCertification = (certId) => {
        let _this = this;
        confirm({
            content: '确认要删除该用户的参赛认证吗？',
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                _this.onDeleteCertificationSubmit(certId);
            },
            onCancel() {
            },
        });
    }

    onDeleteCertificationSubmit = async (certId) => {
        console.log(certId);
        const {onDeletePersonCertification} = this.props;

        await onDeletePersonCertification(certId);
        this.setState({
            loading: true
        });
        await this.onGetTableData();
        message.success("删除成功");
    }


    //条件查找动态方法
    onFilterCertificationEvent = async (values) => {
        const {size, status} = this.state;
        const {getPersonCertificationList} = this.props;
        this.setState({
            loading: true
        })
        await getPersonCertificationList({
            page: 1, size: size,
            ...values
        });
    }

    // changeTabPane = async (key) => {
    //     const {size,} = this.state;
    //     const {getPersonCertificationList} = this.props;
    //     this.setState({
    //         status: key ? key : null,
    //         page: 1,
    //         brandId: null,
    //         game: null,
    //         teamShowId: null,
    //         teamName: null,
    //         leaderQQ: null,
    //         loading: true
    //     })
    //     await getPersonCertificationList({
    //         page: 1, size: size,
    //         status: key ? key : null
    //     });
    // }

    renderTableTitle = () => {
        return (
            <Row type="flex" justify="end">
                <Col>
                    <Button type="primary"
                            onClick={() => this.setState({isShowAddCertificationModel: true})}>新增认证</Button>
                </Col>
            </Row>
        )
    }

    renderTabPane = () => {
        const {
            personCertifications, games
        } = this.props;
        const {
            isShowCertificationInfoModel, isShowUpdateCertificationInfoModel, isShowAddCertificationModel, seletionValue, page, size, status, loading, previewVisible, previewImage,
        } = this.state;
        return (
            <div>
                <Card style={{marginBottom: 30}}>
                    <CertificationFilter value={status} onCommit={this.onFilterCertificationEvent}/>
                </Card>

                <Card>
                    <Table
                        dataSource={personCertifications ? personCertifications.data : []}
                        columns={this.getTableColumns(games)}
                        title={this.state.status === "SUCCESS" ? this.renderTableTitle : null}
                        bordered
                        pagination={{
                            // total: teams ? teams.total : 0,
                            total: personCertifications.total,
                            current: page,
                            pageSize: size,
                            onChange: this.onPageChangeEvent,
                            showTotal: (total) => {
                                return `总计 ${total}条数据`;
                            }
                        }}
                        loading={loading}
                    />
                    {isShowCertificationInfoModel ? <CertificationInfoModel
                        value={seletionValue}
                        onSuccess={this.onFormSubmitConfirm}
                        visible={isShowCertificationInfoModel}
                        onClose={() => {
                            this.setState({
                                isShowCertificationInfoModel: !isShowCertificationInfoModel,
                            });
                        }}
                    /> : null}
                    {isShowAddCertificationModel ? <AddCertificationModel
                        onSuccess={this.onAddFormSubmitConfirm}
                        visible={isShowAddCertificationModel}
                        onClose={() => {
                            this.setState({
                                isShowAddCertificationModel: !isShowAddCertificationModel,
                            });
                        }}
                    /> : null}
                    {isShowUpdateCertificationInfoModel ? <UpdateCertificationModel
                        value={seletionValue}
                        onSuccess={this.onUpdateFormSubmitConfirm}
                        visible={isShowUpdateCertificationInfoModel}
                        onClose={() => {
                            this.setState({
                                isShowUpdateCertificationInfoModel: !isShowUpdateCertificationInfoModel,
                            });
                        }}
                    /> : null}
                </Card>

                {previewVisible ?
                    <Modal width={'80%'} visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                        <div style={{width: '100%', textAlign: 'center'}}>
                            <img alt="example" src={previewImage}/>
                        </div>
                    </Modal> : null}
            </div>
        )
    }

    render() {
        return (
            <div>
                {/* <Tabs onChange={this.changeTabPane} type="card">
                    <TabPane tab="参赛认证列表(审核中)" key="REVIEW">
                        {this.state.status === "REVIEW" ? this.renderTabPane() : null}
                    </TabPane>
                    <TabPane tab="参赛认证列表(通过)" key="SUCCESS">
                        {this.state.status === "SUCCESS" ? this.renderTabPane() : null}
                    </TabPane>
                    <TabPane tab="参赛认证列表(拒绝)" key="FAIL">
                        {this.state.status === "FAIL" ? this.renderTabPane() : null}
                    </TabPane>
                </Tabs> */}
                {this.renderTabPane()}
            </div>
        );
    }

    onGetCertificationInfoEvent = async (value) => {
        const {isShowCertificationInfoModel} = this.state;
        this.setState({
            seletionValue: value,
            isShowCertificationInfoModel: !isShowCertificationInfoModel,
        });
    }

    onUpdateCertificationInfoEvent = async (value) => {
        const {isShowUpdateCertificationInfoModel} = this.state;
        this.setState({
            seletionValue: value,
            isShowUpdateCertificationInfoModel: !isShowUpdateCertificationInfoModel,
        });
    }


    handleCancel = () => this.setState({previewVisible: false});
    showPreviewImage = (value) => {
        this.setState({previewImage: value, previewVisible: true});
    }

    getTableColumns = (games) => [{
        title: '品牌赛事名',
        dataIndex: 'brandName',
        align: 'center',
        key: 'brandName',
    }, {
        title: '用户名称',
        dataIndex: 'userName',
        align: 'center',
        key: 'userName',
    }, {
        title: '用户ID',
        dataIndex: 'exhibitionId',
        align: 'center',
        key: 'exhibitionId',
    }, {
        title: '创建时间',
        dataIndex: 'createTime',
        align: 'center',
        key: 'createTime',
    }, {
        title: '操作',
        dataIndex: 'details',
        key: 'details',
        align: 'center',
        render: (row, text) => (
            <div>
                <Button type="primary" style={{marginLeft: 10, marginBottom: 10}} onClick={() => this.onUpdateCertificationUpOrDown(text, 'UP')}>{"升级"}</Button>
                <Button type="primary" style={{marginLeft: 10, marginBottom: 10}} onClick={() => this.onUpdateCertificationUpOrDown(text, 'DOWN')}>{"降级"}</Button>
                <Button type="primary" style={{marginLeft: 10, marginBottom: 10}} onClick={() => this.onUpdateUserSuspend(text.id, text.suspend)}>{text.suspend ? "已禁赛" : "禁赛"}</Button>
                <Button type="danger" style={{marginLeft: 10, marginBottom: 10}} onClick={() => this.onDeleteCertification(text.id)}>{"删除"}</Button>
            </div>
        ),
    }]
}

const mapStateToProps = (state) => {
    console.log(state)
    return {
        ...state.Team,
        ...state.Certification
    }
};

const mapDispatchToProps = ({
    getGameList,
    getPersonCertificationList, addPersonCertification,
    getTeamCertificationInfo,
    verifyCertifiacation, onUpdatePersonCertificationUpOrDown,
    onUpdatePersonUserSuspend,
    onDeletePersonCertification
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Certification));
